'use client'

import { Container } from '@mui/material'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AccessDenied } from 'app/components/AccessDenied'
import { FaqDrawer } from 'app/components/FaqDrawer'
import { Loading } from 'app/components/Loading'
import { useAppService } from 'app/services/main/AppService'
import { FeedbackSurveyDialog } from 'app/components/FeedbackSurveyDialog'
import { useFeedbackCampaign } from 'app/services/hooks/useFeedbackCampaign'
import { Header } from './Header'

function Layout() {
  const { loading, isAuthorised, authStartupStatus } = useAppService()
  const feedback = useFeedbackCampaign(Boolean(isAuthorised && !loading))
  const [faqOpen, setFaqOpen] = useState(false)

  const isAuthResolving =
    authStartupStatus === 'bootstrapping_identity' ||
    authStartupStatus === 'acquiring_token_silent' ||
    authStartupStatus === 'validating_backend_token' ||
    authStartupStatus === 'redirecting_to_sso'

  if (loading || isAuthResolving) {
    return <Loading />
  }

  if (!isAuthorised) {
    return <AccessDenied />
  }

  return (
    <>
      <Header onHelpClick={() => setFaqOpen((prev) => !prev)} />
      <FeedbackSurveyDialog
        campaign={feedback.campaign}
        open={Boolean(feedback.campaign)}
        isActing={feedback.isActing}
        onTakeSurvey={() => {
          feedback.takeSurvey()
        }}
        onAlreadyTaken={() => {
          feedback.completeSurvey()
        }}
        onMaybeLater={() => {
          feedback.snoozeSurvey()
        }}
      />
      <FaqDrawer open={faqOpen} onClose={() => setFaqOpen(false)} />
      <Container
        maxWidth='xl'
        disableGutters
        className='px-4 pt-4 pb-0 bg-[#F1F1F1] fixed overflow-auto top-[90px]'
        sx={{ height: '-webkit-fill-available', justifySelf: 'center' }} // TODO: padding bottom not working
      >
        <Outlet />
      </Container>
    </>
  )
}

export default Layout
